"use client";

import { c as _c } from "react/compiler-runtime";
import { useSessionOptional } from "@/contexts/SessionContext";

/**
 * Session Timeout Warning Modal
 * Shows when session is about to expire, allowing user to extend or logout
 */
export function SessionTimeoutWarning() {
  const $ = _c(15);
  const session = useSessionOptional();
  if (!session || !session.showTimeoutWarning) {
    return null;
  }
  const {
    timeRemaining,
    extendSession,
    endSession
  } = session;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-4 flex justify-center"><div className="flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30"><svg className="h-6 w-6 text-amber-600 dark:text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></div></div>;
    t1 = <h2 className="mb-2 text-center text-lg font-semibold text-zinc-900 dark:text-white">Session Expiring Soon</h2>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== timeRemaining) {
    t2 = <p className="mb-4 text-center text-sm text-zinc-600 dark:text-zinc-400">Your session will expire in{" "}<span className="font-mono font-semibold text-amber-600 dark:text-amber-400">{timeRemaining}</span>{" "}due to inactivity. Would you like to stay logged in?</p>;
    $[2] = timeRemaining;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== endSession) {
    t3 = <button onClick={() => endSession("manual_logout")} className="flex-1 rounded-lg border border-zinc-300 px-4 py-2 text-sm font-medium text-zinc-700 transition-colors hover:bg-zinc-50 dark:border-zinc-700 dark:text-zinc-300 dark:hover:bg-zinc-800">Log Out</button>;
    $[4] = endSession;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== extendSession) {
    t4 = <button onClick={extendSession} className="flex-1 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700">Stay Logged In</button>;
    $[6] = extendSession;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="flex gap-3">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className="mt-4 text-center text-xs text-zinc-500 dark:text-zinc-500">For your security, sessions automatically expire after periods of inactivity.</p>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t5) {
    t7 = <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm"><div className="mx-4 w-full max-w-md rounded-lg bg-white p-6 shadow-xl dark:bg-zinc-900">{t0}{t1}{t2}{t5}{t6}</div></div>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}